import { useState } from 'react';
import SectionHeader from './SectionHeader';
import { faqItems } from '../../../mocks/gossip';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeader align="center" eyebrow="常见问题" title="吃瓜前，你可能想知道的" desc="关于实时直播机制、事件状态与吃瓜边界的常见疑问，一并在这里为你解答。" />

        <div className="flex flex-col gap-3">
          {faqItems.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-start gap-3 text-base font-semibold text-foreground-900">
                    <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'}`}>
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    {f.q}
                  </span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <p className="border-t border-background-100 px-5 py-4 pl-14 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}